// extracted by mini-css-extract-plugin
export default {"component":"pb2NA","qrCode":"MlUOp","buttonsGroup":"GVVq7"};